<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>订单信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">商品名称</div>
              <div class="itemNum">{{ form.itemName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">订单来源</div>
              <div class="itemNum">{{ form.sourceCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">订单状态</div>
              <div class="itemNum">{{ form.orderStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">订单金额</div>
              <div class="itemNum moneys">￥{{ form.orderAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">是否使用现金券</div>
              <div class="itemNum">{{ form.couponCardUse == 'yes' ?'是':'否' }}</div>
            </div>
            <div class="flex-row mb30">
                <div class="itemName">现金券券号</div>
                <div class="itemNum">{{ form.couponCode }}</div>
              </div>
            <div class="flex-row mb30">
              <div class="itemName">优惠金额</div>
              <div class="itemNum">￥{{ form.discountAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">付款金额</div>
              <div class="itemNum moneys">￥{{ form.realPayAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">订单号</div>
              <div class="itemNum">{{ form.orderNo }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">支付方式</div>
              <div class="itemNum">{{ form.payWayCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">创建时间</div>
              <div class="itemNum">{{ formatDate(form.oxCtime) }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.orderStatus == 'invalid'">
              <div class="itemName">作废时间</div>
              <div class="itemNum">{{ formatDate(form.oxLtime) }}</div>
            </div>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import drawer from "../../../components/common/drawer";
import minxin from "../../../assets/javascript/minxin.js";
export default {
  mixins: [minxin],
  components: {
    drawer,
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "订单详情",
      form: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        this.$api.get(this.$url.shopServe.recordsGet, {
            id: org
          }).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
            }
          }).catch(error => {});
      });
    },
    back () {
      this.addEditShow = false;
    },
  }
};
</script>
<style scoped lang="less">
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  .titles-head {
    border-top: 0;
  }
  .order-details {
    height: 56px;
    line-height: 56px;
    background: #F7F8FA;
  }
}
</style>